import { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Typography,
  Modal,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import './Gallery.css';
import ParallaxHeader from '../components/ParallaxHeader';

// List all images in public/images/gallery (add new ones here as needed)
const galleryImageFiles = [
  'IMG_1191.jpg',
  'IMG_1418.jpg',
  'IMG_1563.jpg',
  'IMG_1743.jpg',
  'IMG_1905.jpg',
  'IMG_2974.jpg',
  'IMG_3114.jpg',
  'IMG_3775.jpg',
];

const galleryImages = galleryImageFiles.map((filename) => ({
  img: `/images/gallery/${filename}`,
  title: filename,
}));

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <ParallaxHeader
        title="Our Work"
        description="Browse our portfolio of transformations and styles"
        imageUrl="/images/content/cleaning-bd40e1a3-7f6e-43e8-b8fb-72e1d1bfc335.png"
        height={300}
      />
      <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
        <Container maxWidth="lg">
          {/* Gallery Grid */}
          <div className="gallery-grid" style={{ marginBottom: 32 }}>
            {galleryImages.map((item) => (
              <div
                key={item.img}
                className="gallery-img-container"
                onClick={() => setSelectedImage(item.img)}
                tabIndex={0}
                role="button"
                aria-label={`Expand image ${item.title}`}
                style={{ outline: 'none' }}
              >
                <img
                  src={item.img}
                  alt={item.title}
                  className="gallery-img"
                  loading="lazy"
                />
                <div className="sheen" />
              </div>
            ))}
          </div>

          {/* Image Modal */}
          <Modal
            open={!!selectedImage}
            onClose={() => setSelectedImage(null)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 2,
            }}
          >
            <Box
              sx={{
                position: 'relative',
                maxWidth: '90vw',
                maxHeight: '90vh',
                outline: 'none',
                bgcolor: 'background.paper',
                borderRadius: 2,
                p: 2,
                boxShadow: 24,
              }}
            >
              {selectedImage && (
                <img
                  src={selectedImage}
                  alt="Expanded gallery"
                  className="modal-img"
                  style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                />
              )}
            </Box>
          </Modal>

          {/* Call to Action */}
          <Box sx={{ textAlign: 'center', mt: 6 }}>
            <Typography variant="h4" gutterBottom>
              Ready for Your Transformation?
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              href="https://app.salonrunner.com/customer/directory/index.htm?id=35742"
              target="_blank"
              sx={{ mt: 2, py: 1.5, px: 4, fontSize: '1.1rem' }}
            >
              Book Your Appointment
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Gallery;
